import React from 'react';
import { Typography, Button, Card, CardContent, Grid, useTheme, Box } from '@mui/material';

const ThemeVisualizer = () => {
    const theme = useTheme(); // Access the current theme

    return (
        <Box maxWidth="lg" style={{ marginTop: '2rem' }}>
            <Grid container spacing={4}>
                {/* Typography Examples */}
                <Grid item xs={12}>
                    <Typography variant="h1" gutterBottom>
                        Theme Visualization
                    </Typography>
                    <Typography variant="h2" gutterBottom>
                        Explore the Effects of Light and Dark Themes
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        This page displays how various Material-UI components like Typography, Buttons, and Cards look when light or dark themes are applied. Toggle the theme in the header to see the difference.
                    </Typography>
                </Grid>

                {/* Button Examples */}
                <Grid item xs={12} sm={6}>
                    <Button variant="contained" color="primary" fullWidth>
                        Primary Button
                    </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Button variant="outlined" color="secondary" fullWidth>
                        Secondary Button
                    </Button>
                </Grid>

                {/* Card Example */}
                <Grid item xs={12} sm={6}>
                    <Card>
                        <CardContent>
                            <Typography variant="h5" gutterBottom>
                                Example Card
                            </Typography>
                            <Typography variant="body2">
                                This is a simple example of a card component, styled according to the current theme.
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Additional Components Example */}
                <Grid item xs={12} sm={6}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Secondary Card
                            </Typography>
                            <Typography variant="body2">
                                This is another card to demonstrate more components being styled under different themes.
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ThemeVisualizer;
